import api from '@pray/shared/utils/api';

export async function updateContentSeries({
  artistId,
  contentSeriesId,
  title = undefined,
  description = undefined,
  imageUrl = undefined,
  portraitImageUrl = undefined,
  landscapeImageUrl = undefined,
  isVisible = undefined,
  orderIdBefore = undefined,
  orderIdAfter = undefined,
  distributionOwnerEmail = undefined,
  contentOrder = undefined,
  emailTemplateId = undefined,
  leadSegmentId = undefined,
  externalUrl = undefined,
  displayDate = undefined,
  sourceLocaleCode = undefined,
}) {
  if (!artistId) throw Error('Artist ID is required');
  if (!contentSeriesId) throw Error('Content Series ID is required');

  const data = {};

  if (title) data.title = title;
  if (description) data.description = description;
  if (imageUrl) data.image_url = imageUrl;
  if (portraitImageUrl) data.portrait_image_url = portraitImageUrl;
  if (landscapeImageUrl) data.landscape_image_url = landscapeImageUrl;
  if (isVisible !== undefined) data.is_visible = isVisible;
  if (orderIdBefore !== undefined) data.order_number_for_artist_id_before = orderIdBefore;
  if (orderIdAfter !== undefined) data.order_number_for_artist_id_after = orderIdAfter;
  if (distributionOwnerEmail !== undefined) data.distribution_owner_email = distributionOwnerEmail;
  if (contentOrder !== undefined) data.content_order = contentOrder;
  if (emailTemplateId !== undefined) data.email_template_id = emailTemplateId;
  if (leadSegmentId !== undefined) data.lead_segment_id = leadSegmentId;
  if (displayDate !== undefined) data.display_date = displayDate;
  // null is a valid value (clears source language back to English default), so guard on undefined only.
  if (sourceLocaleCode !== undefined) data.source_locale_code = sourceLocaleCode;

  // External URLs must have a valid link or be null to be updated
  data.external_url = externalUrl || null;

  const url = `/web/studio/artists/${artistId}/content-series/${contentSeriesId}`;
  const response = await api.executePutRequest(url, data);

  return response.data.data;
}
